import { module } from 'stereomodularjs';
import Splide from '@splidejs/splide'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.slider = new Splide(this.el, {
            type: 'loop',
            autoplay:1000,
            perPage: 1,
            gap:'40px',
            arrows: true,
            pagination: false,
            // breakpoints: {
            //     1800: {
            //         perPage: 5
            //     },
            //     1200: {
            //         perPage: 4
            //     },
            //     800: {
            //         perPage: 3
            //     },
            //     480: {
            //         perPage: 2
            //     },
            //     380: {
            //         perPage: 1
            //     }
            // }
        }).mount();
    }
}